class Hero {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;

        self.body = document.body;
        self.html = document.documentElement;
        self.img = self.elem.querySelector('[data-hero-img]');
        self.end = self.elem.querySelector('[data-hero-end]');
    }

    init() {
        let self = this;

        self.changeOpacity();
    }

    changeOpacity() {
        let self = this;

        document.addEventListener('scroll', (e) => {
            let scrollTop = window.scrollY;
            let docHeight = self.end.offsetTop;
            let scrollPercent = (scrollTop) / (docHeight);
            let scrollFigure = scrollPercent*3;
            let scrollOpactiy = 1 - scrollFigure;

            self.img.style.opacity = scrollOpactiy;
        });
    }
}

export default Hero;
